import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function VerifyEmail() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      fetch(`https://api.sobevenda.com.br/api-proxy/affiliate/auth/verify-email?token=${token}`)
        .then(async (res) => {
          if (!res.ok) {
            const data = await res.json();
            throw new Error(data.message || "Erro ao confirmar e-mail.");
          }
          return res.json();
        })
        .then((data) => {
          if (data.authToken) {
            localStorage.setItem("sobevenda_token", data.authToken);
            navigate("/dashboard");
          } else {
            setLoading(false);
            setError("Confirmação feita, faça login para continuar.");
          }
        })
        .catch((err) => {
          setLoading(false);
          setError(err.message || "Erro ao confirmar e-mail.");
        });
    } else {
      setLoading(false);
      setError("Token inválido.");
    }
  }, [location, navigate]);

  if (loading) return <div className="text-center mt-20">Confirmando e-mail...</div>;
  if (error) return <div className="text-center mt-20 text-red-600">{error}</div>;

  return (
    <div className="text-center mt-20">
      <h2 className="text-2xl font-bold mb-4">E-mail confirmado com sucesso!</h2>
      <a href="/login" className="bg-blue-600 text-white px-6 py-2 rounded-lg">Fazer login</a>
    </div>
  );
}

export default VerifyEmail;
